export function stringWithoutSpaces(str: string): string {
    let result: string = str.replace(/ /g, '');

    return result
}